<!-- <search-vehicle [routeName]="'/vehicle-list-new'"></search-vehicle> -->

<app-bi-search-vehicle [routeName]="'/vehicle-list-new'"></app-bi-search-vehicle>
